import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { toggleSelection, setHotel } from '../../actions/formActions'
import NestedCheckboxList from '../NestedCheckboxList'
import SelectedValue from '../SelectedValue'
import DestinationsApartmentFilter from './DestinationsApartmentFilter'
import './style.scss'
import HotelsList from '../HotelsList'
import Button from '../Button'
import Loader from '../Loader'
import Alert from '../Alert'

const DestinationsApartmentList = ({
    popular,
    selectedDestinations,
    destinations,
    toggleSelection,
    setHotel,
    resetTrigger,
    hotel
}) => {
    const [isSearchMode, setIsSearchMode] = useState(false)
    const [filterDestinations, setFilterDestinations] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [hotels, setHotels] = useState([])
    const [selectedHotel, setSelectedHotel] = useState('')
    const { t } = useTranslation()

    // Pobierz miasta z URL i dodaj je do wybranych wartości dla wyświetlenia
    const getSelectedValuesWithCities = () => {
        if (!selectedDestinations || selectedDestinations === '') {
            return ''
        }

        const params = new URLSearchParams(window.location.search)
        const cityValues = params.getAll('city[]')
        
        if (cityValues.length === 0) {
            return selectedDestinations
        }

        // Jeśli są miasta w URL, dodaj je jako pełne ścieżki i usuń regiony z wyświetlania
        const kierunekValues = selectedDestinations.split(';')
        const citiesWithPaths = []
        const regionsToExclude = new Set()

        kierunekValues.forEach(kierunek => {
            const parts = kierunek.split('.')
            
            // Jeśli kierunek ma 2 poziomy (kraj.region), dodaj miasta jako pełne ścieżki
            if (parts.length === 2) {
                // Oznacz region do wykluczenia z wyświetlania
                regionsToExclude.add(kierunek)
                
                // Dodaj miasta jako pełne ścieżki (kraj.region.miasto)
                cityValues.forEach(city => {
                    citiesWithPaths.push(`${kierunek}.${city}`)
                })
            } else {
                // Jeśli kierunek nie ma 2 poziomów, zostaw go jak jest
                citiesWithPaths.push(kierunek)
            }
        })

        // Usuń duplikaty i zwróć tylko miasta (pełne ścieżki) i wartości które nie są regionami z miastami
        const uniqueValues = [...new Set(citiesWithPaths)]
        return uniqueValues.join(';')
    }

    useEffect(() => {
        // Clear hotels and selection on external reset
        setSelectedHotel('')
        setHotels([])
    }, [resetTrigger])

    // Sync local selection with Redux (URL param or external set)
    useEffect(() => {
        setSelectedHotel(hotel || '')
    }, [hotel])

    const selectItemHandler = (field, nextSelected) => {
        // Jeśli użytkownik klika usuwanie na wartości z 3 poziomami (miasto),
        // usuń odpowiadający region (2 poziomy) z selectedDestinations
        const parts = nextSelected.split('.')
        
        if (parts.length === 3) {
            // To jest miasto - usuń odpowiadający region (kraj.region)
            const regionKey = `${parts[0]}.${parts[1]}`
            
            // Sprawdź czy region istnieje w selectedDestinations
            const currentValues = selectedDestinations ? selectedDestinations.split(';') : []
            if (currentValues.includes(regionKey)) {
                // Usuń region
                toggleSelection(field, regionKey)
            } else {
                // Jeśli region nie istnieje, usuń pełną ścieżkę (jeśli istnieje)
                toggleSelection(field, nextSelected)
            }
        } else {
            // Standardowe usuwanie
            toggleSelection(field, nextSelected)
        }
    }

    const selectHotelHandler = (value) => {
        const next = value === selectedHotel ? '' : value
        setSelectedHotel(next)
        setHotel(next)
        // Nie czyścimy listy hoteli przy odznaczeniu, aby zachować wyniki wyszukiwania
    }

    const handleTransportChangeLoading = (loading) => {
        setIsLoading(loading)
        if (loading) {
            // Transport się zmienia – wyczyść listę hoteli i wybór hotelu
            setHotels([])
            setSelectedHotel('')
        }
    }

    const hasDirectionResults = isSearchMode ? (
        filterDestinations && typeof filterDestinations === 'object' && Object.keys(filterDestinations).length > 0
    ) : true

    const noResults = isSearchMode && !isLoading && !hasDirectionResults && hotels.length === 0

    return (
        <>
            <div className="trip-modal__columns">
                <div className="transport-group">
                    <DestinationsApartmentFilter
                        currentData={destinations}
                        placeholder={t('modal.destinations.filter_placeholder')}
                        toggleFilterMode={setIsSearchMode}
                        onChange={setFilterDestinations}
                        resetTrigger={resetTrigger}
                        onHotelsChange={setHotels}
                        onHotelsLoading={setIsLoading}
                    />
                </div>
            </div>
            {isLoading ? (
                <div className="trip-modal__columns">
                    <Loader />
                </div>
            ) : noResults ? (
                <div className="trip-modal__columns">
                    <div style={{ width: '100%' }}>
                        <Alert variant="info" message={'Brak wyników'} />
                    </div>
                </div>
            ) : (
                <div className="trip-modal__columns trip-modal__columns--2">
                    <div className="trip-modal__col trip-modal__col--order-mobile-2">
                        {isSearchMode ?
                            (
                                <>
                                    {hasDirectionResults && (
                                        <>
                                            <h4 className="trip-modal__title trip-modal__title--small">
                                                {t('modal.destinations.country_list')}
                                            </h4>
                                            <NestedCheckboxList
                                                field='kierunek'
                                                data={filterDestinations}
                                                expanded={true}
                                                uniquePrefix='kp'
                                                selected={selectedDestinations || ''}
                                                onChange={selectItemHandler}
                                            />
                                        </>
                                    )}
                                </>
                            ):
                            (
                                <>
                                    {/*
                                    <h4 className="trip-modal__title trip-modal__title--small">
                                        {t('modal.destinations.section_popular')}
                                    </h4>
                                    <NestedCheckboxList
                                        field="kierunek"
                                        data={popular}
                                        uniquePrefix="kp"
                                        selected={selectedDestinations || ''}
                                        onChange={selectItemHandler}
                                    />*/}
                                    <h4 className="trip-modal__title trip-modal__title--small">
                                        {t('modal.destinations.country_list')}
                                    </h4>
                                    <NestedCheckboxList
                                        field="kierunek"
                                        data={destinations}
                                        uniquePrefix="kl"
                                        selected={selectedDestinations || ''}
                                        onChange={selectItemHandler}
                                    />
                                </>
                            )
                        }
                        {hotels.length > 0 && (
                            <>
                                {hasDirectionResults && <hr className="trip-modal__separator" />}
                                <h4 className="trip-modal__title trip-modal__title--small">
                                    {t('modal.destinations.section_hotels')}
                                </h4>
                                <HotelsList
                                    hotels={hotels}
                                    selectedHotel={selectedHotel}
                                    onSelect={selectHotelHandler}
                                />
                            </>
                        )}
                    </div>
                    <div className="trip-modal__col trip-modal__col--order-mobile-1">
                        <SelectedValue
                            header={t('common.selected_header')}
                            selectedValues={getSelectedValuesWithCities()}
                            field="kierunek"
                            onRemove={selectItemHandler}
                        />
                        {selectedHotel !== '' && (
                            <div className="selected-values__content" style={{ marginTop: 8 }}>
                                <Button
                                    variant="remove"
                                    type="button"
                                    label={selectedHotel}
                                    clickHandler={() => {
                                        setSelectedHotel('')
                                        setHotel('')
                                    }}
                                />
                            </div>
                        )}
                    </div>
                </div>
            )}
        </>
    )
}

DestinationsApartmentList.propTypes = {
    popular: PropTypes.array,
    selectedDestinations: PropTypes.string,
    destinations: PropTypes.object,
    toggleSelection: PropTypes.func,
    setTransport: PropTypes.func,
    setHotel: PropTypes.func,
    hotel: PropTypes.string,
}

const mapStateToProps = (state) => ({
    selectedDestinations: state.formReducer.kierunek,
    hotel: state.formReducer.hotel,
})

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            toggleSelection,
            setHotel
        },
        dispatch
    )

export default connect(mapStateToProps, mapDispatchToProps)(DestinationsApartmentList)
